import { createContext, useContext, useEffect, useState } from "react";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
// import firebase from "firebase/compat/app";
import { auth } from "./firebase";
import { useHistory } from "react-router-dom";

const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];

const UserContext = createContext();
export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState({});

  let timer;
  const navigate = useHistory();

  const createUser = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const signIn = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const logout = () => {
    return signOut(auth);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      // console.log(currentUser);
      setUser(currentUser);
    });

    return () => {
      unsubscribe();
    };
  }, []);


  // const handleLogoutTimer = () => {
  //   timer = setTimeout(() => {
  //     resetTimer();
  //     Object.values(events).forEach((item) => {
  //       window.removeEventListener(item, resetTimer);
  //     });
  //     logoutAction();
  //   }, 10000); // 10000ms = 10secs. 
  // };

  // const resetTimer = () => {
  //   if (timer) clearTimeout(timer);
  // };

  // useEffect(() => {
  //   Object.values(events).forEach((item) => {
  //     window.addEventListener(item, () => {
  //       resetTimer();
  //       handleLogoutTimer();
  //     });
  //   });
  // }, []);

  // const logoutAction = () => {
  //   logout();
  //   //localStorage.clear();
  //   //window.location.pathname = "/login";
  //   // try{
  //   navigate.push("/");
  //   // <Link to="/login" />
  //   console.log("Auto Logged Out");
  //   // } catch (err) {
  //   //   console.error(err);
  //   //   alert(err.message);
  //   // }
  // }  

  // this.firebaseAuth.authStateChanges((currentUser) => {
  //   let userSessionTimeout = null;

  //   if (currentUser === null && userSessionTimeout) {
  //     clearTimeout(userSessionTimeout);
  //     userSessionTimeout = null;
  //   } else {
  //     currentUser.getIdTokenResult().then((idTokenResult) => {
  //       const authTime = idTokenResult.claims.auth_time * 1000;
  //       const sessionDurationInMilliseconds = 30 * 1000; // 60 min
  //       const expirationInMilliseconds =
  //         sessionDurationInMilliseconds - (Date.now() - authTime);
  //       userSessionTimeout = setTimeout(
  //         () => this.firebaseAuth.signOut(),
  //         expirationInMilliseconds
  //       );
  //     });
  //   }
  // });

  return (
    <UserContext.Provider
      value={{ createUser, user, logout, signIn }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const UserAuth = () => {
  return useContext(UserContext);
};
